import { record } from 'io-ts/Decoder';

import { AudienceDecisions } from '../../../../../../transaction/review/AudienceDecisions';

export const Request = record(AudienceDecisions);
